<template>
  <v-container>
    <v-layout>
    <v-flex>
       <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newCompany"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Cliente</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    
      <v-dialog
        v-model="dialog"
        fullscreen hide-overlay
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile >
          <v-card-text overflow-y height="100%">
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Cliente</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-tabs dark
                  slider-color="yellow" show-arrows
                  v-model="active">
            <v-tab>
              Datos Cliente
            </v-tab>
            <v-tab-item>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-text-field
                              name="codigo"
                              label="Cédula/RUC"
                              id="code"
                              :rules="codeRules"
                              :counter="13"
                              required
                              v-model="company.code"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-text-field
                              name="nombre"
                              label="Nombre"
                              id="nombre"
                              :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                              v-model="company.name"
                              required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm7 offset-sm1>
                      <v-text-field
                              name="direccion"
                              label="Dirección"
                              id="direccion"
                              :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                              v-model="company.address"
                              required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-text-field
                              name="telefono"
                              label="Teléfono"
                              id="telefono"
                              :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                              v-model="company.phone"
                              required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-text-field
                              name="representante"
                              label="Representante"
                              id="representante"
                              :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                              v-model="company.agent"
                              required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
             <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-combobox
                        v-model="company.ciiu"
                        :items="this.$store.state.catalogs"
                        label="CIIU">
                      </v-combobox>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-textarea
                              name="observaciones"
                              label="Observaciones"
                              id="observaciones"
                              :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                              v-model="company.observation"
                              required
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm4 offset-sm1>
                      <v-select
                              v-model="company.costCenter"
                              :items="itemsDecision"
                              label="Centro de Costos"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm10 offset-sm1>
                      <v-switch
                              label="Inactivo / Activo"
                              v-model="company.status"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs12 sm6 offset-sm4>
                      <div>
                        <v-btn :disabled="!valid"
                               @click="saveData"  large color="primary">Guardar</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-tab-item>
            <v-tab :disabled="this.disabledTab">
              Hojas de Ruta
            </v-tab>
            <v-tab-item lazy>
              <hoja-de-ruta :company="company"></hoja-de-ruta>
            </v-tab-item>
            <v-tab :disabled="this.disabledTab">
              Agencias/Sucursal/Puesto
            </v-tab>
            <v-tab-item lazy>
              <company-agency :company="company"></company-agency>
            </v-tab-item>
            <v-tab :disabled="this.disabledTab">
              Puestos de Trabajo
            </v-tab>
            <v-tab-item lazy>
              <company-job :company="company"></company-job>
            </v-tab-item>
            <v-tab :disabled="this.disabledTab">
              Grupo Homogéneo de exposición
            </v-tab>
            <v-tab-item lazy>
              <grupo-homogenio-exposicion :company="company"></grupo-homogenio-exposicion>
            </v-tab-item>
            <v-tab :disabled="this.disabledTab">
              Matriz de procesos peligrosos
            </v-tab>
            <v-tab-item lazy>
              <matriz-procesos-peligrosos :company="company"></matriz-procesos-peligrosos>
            </v-tab-item>
            <v-tab :disabled="this.disabledTab" :to="{name: 'proessat', props:{company:'company'}}" >
              Guías PROESSAT
            </v-tab>
            <v-tab-item lazy>
            </v-tab-item>
          </v-tabs>

          <div style="flex: 1 1 auto;"></div>
          </v-card-text>
        </v-card>

      </v-dialog>
    
    </v-layout>
       <h3 class="primary--text">Lista de Clientes</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.companies"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">         
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>          
          <td class="text-xs-left">{{ props.item.status?"Activo":"Inactivo" }}</td>
          <td>
            <v-tooltip top >
               <v-btn 
               fab dark 
               small @click="editItem(props.item)" 
               slot="activator"
               color="primary">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <span>Editar</span>
              </v-tooltip>
              <v-tooltip top >
                <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                  <v-icon dark>delete</v-icon>
                </v-btn>
              <span>Eliminar</span>
              </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>

  import Company from "../../model/Company";
  import GuiaProessat from './guiaProessat/GuiaProessat'
  import CompanyAgency from './companyAgency/CompanyAgency'
  import CompanyJob from './companyJob/CompanyJob'
  import HojaDeRuta from './hojaDeRuta/HojaDeRuta'
  import GrupoHomogenioExposicion from "./grupoHomogenioExposicion/GrupoHomogenioExposicion";
  import MatrizProcesosPeligrosos from "./matrizProcesosPeligrosos/MatrizProcesosPeligrosos";

  export default {    
    data () {
      return {
        dialog: false,
        search: '',
        valid: false,
        codeRules: [
          v => !!v || 'El código es requerido',
          v => (v && v.length <= 13) || 'El código debe tener 10 o 13 caracteres'
        ],
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        headers: [
          { text: 'Cédula/RUC', value: 'code' },
          { text: 'Nombre', value: 'name' },          
          { text: 'Estado', value: 'estado' },
          { text: 'Acciones', value: 'editar' },

        ],
        editedIndex: -1,
        company: new Company(),
        itemsDecision: ['Si', 'No'],
        agencies:[],
        disabledTab: true,
        active: 0
      };
    },
    methods:{
      cleanData(){
        this.valid = false
        this.dialog= false
        this.$refs.form.reset()
        this.company= new Company()
      },
      newCompany(){
        this.editedIndex = -1
        this.dialog= true
        this.valid = false
        this.$refs.form.reset()
        this.company = new Company()
        this.$store.state.companyAgencies = []
        this.$store.state.companyJobs = []
        this.disabledTab = true
        this.active = 0
      },
      saveData(){       
        if (this.validarCedulaRuc()) {         
          if(this.$refs.form.validate()){
            if (this.company.ciiu.field != null) {
              let ciiuAux = this.company.ciiu.field;
              this.company.ciiu = {id: ciiuAux};              
            }
            if (this.editedIndex > -1) {
              this.$store.dispatch('updateCompany',this.company).then(response => {
                this.cleanData()
              }, error => {
                this.$store.state.progress = false
                this.$store.state.dialogError = true
              })
            } else {
              this.$store.dispatch('addCompany',this.company).then(response => {
                this.cleanData()
              }, error => {
                this.$store.state.progress = false
                this.$store.state.dialogError = true
              })
            }
            this.dialog = false
          }
        }
      },
      editItem (item) {
        this.disabledTab = false;
        this.editedIndex = this.$store.state.companies.indexOf(item)
        this.company = Object.assign({}, item)
        this.$store.state.companyAgencies = []
        this.$store.state.companyJobs = []
        this.$store.state.company = this.company
        
        //Se carga datos de Agencias
        if(this.company.id != ""){
            this.$store.dispatch('getCompanyAgenciesByCompany',this.company.id).then(
                response => {
                },
                error => {
                    this.$store.state.dialogError = true;
                }
            )
          this.$store.dispatch('getCompanyJobsByCompany',this.company.id).then(
                  response => {
                  },
                  error => {
                    this.$store.state.dialogError = true;
                  }
          )
            this.$store.dispatch('getGuiasProessatByCompany',this.company.id).then(
                response => {
                },
                error => {
                    this.$store.state.dialogError = true;
                }
            );
          this.$store.dispatch('getGruposHomogenio',this.company.id).then(
                  response => {
                  },
                  error => {
                    this.$store.state.dialogError = true;
                  }
          );
          this.$store.dispatch('getDangerousProcess',this.company.id).then(
                  response => {
                  },
                  error => {
                    this.$store.state.dialogError = true;
                  }
          );
        }
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.$store.state.companies.indexOf(item)
        this.company = Object.assign({}, item)
        confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deleteCompany',this.company.id)
      },
      validarCedulaRuc() {
        if(this.editedIndex == -1){
          for(let i=0; i<this.$store.state.companies.length; i++){
            if(this.$store.state.companies[i].code == this.company.code){
              this.$store.state.dialogErrorMessage = "Cliente ya registrado en el sistema, intente con otra identificacion"
              this.$store.state.progress = false
              this.$store.state.dialogError = true
              return false
            }
          }
        }
          let cad = this.company.code;
          let total = 0;
          let longitud = cad.length;
          let longcheck = longitud - 1;

          if (cad !== "" && longitud === 10){
              for(let i = 0; i < longcheck; i++){
                  if (i%2 === 0) {
                      let aux = cad.charAt(i) * 2;
                      if (aux > 9) aux -= 9;
                      total += aux;
                  } else {
                      total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
                  }
              }
              total = total % 10 ? 10 - total % 10 : 0;
              if (cad.charAt(longitud-1) != total) {
                  this.$store.state.dialogErrorMessage = "Cédula inválida";
                  this.$store.state.dialogError = true
                  return false;
              }
              return true;
          }

          if (cad !== "" && longitud !== 10 && longitud !== 13) {
              this.$store.state.dialogErrorMessage = "Debe ingresar una cédula o RUC válido.";
              this.$store.state.dialogError = true
              return false;
          }
          return true;
      }
    },
      computed : {
      },
      beforeCreate(){
        this.$store.dispatch('getCompanies').then(response => {
          this.cleanData()
        }, error => {
          this.$store.state.dialogError = true
        }),
                this.$store.dispatch('getTypes').then(
                        response => {
                          this.cleanData();
                        },
                        error => {
                          this.$store.state.dialogError = true;
                        }
                );
      },
      components: {
        GuiaProessat,
        CompanyAgency,
        CompanyJob,
        HojaDeRuta,
        GrupoHomogenioExposicion,
        MatrizProcesosPeligrosos
      }
    }
</script>

<style scoped>
  li{
    list-style:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Company.vue